import cn from 'classnames';

import Accordion from 'components/accordion/Accordion';
import Byline from 'components/byline/Byline';
import Link from 'components/link/Link';
import OptionsModal from 'components/options-modal/OptionsModal';

import { IArticleHeader } from 'source/NFR.types';

interface ArticleHeaderProps extends IArticleHeader {
  isLargeArticle?: boolean;
}

const ArticleHeader: React.FC<ArticleHeaderProps> = ({
  accordion,
  byline = { items: [] },
  links,
  share,
  isLargeArticle
}) => {
  return (
    <div className={cn('article-header', { 'article-header--is-large-article': isLargeArticle })}>
      {!!byline.items.length && (
        <>
          {/* Mobile version */}
          {accordion ? (
            <Accordion {...accordion}>
              {({ Button, Collapse, isOpen, toggle }) => (
                <div className="article-header--byline article-header--byline--is-mobile">
                  <div className="article-header--byline-header">
                    <p onClick={toggle}>{byline.items[0].text}</p>
                    <Button
                      className={cn('article-header--toggle', {
                        'article-header--toggle--is-active': isOpen
                      })}
                      icon="micro-arrow-down"
                    />
                  </div>
                  <Collapse>
                    <div className="article-header--byline-content">
                      <Byline items={byline.items.slice(1)} />
                      {share && (
                        <div className="article-header--links">
                          <OptionsModal {...share} theme="isArticleHeader"></OptionsModal>
                        </div>
                      )}
                      {links?.map((link, i) => (
                        <div key={i} className="article-header--download-label">
                          <Link {...link} iconBeforeChildren="download-round" />
                        </div>
                      ))}
                    </div>
                  </Collapse>
                </div>
              )}
            </Accordion>
          ) : (
            <div className="article-header--byline article-header--byline--is-mobile">
              <div className="article-header--byline-content">
                <Byline items={byline.items.slice(1)} />
                {links?.map((link, i) => (
                  <div key={i} className="article-header--download-label">
                    <Link {...link} />
                  </div>
                ))}
              </div>
            </div>
          )}

          {/* Desktop version */}
          <div className="article-header--byline article-header--byline--is-desktop">
            <Byline {...byline} />

            <div className="article-header--links article-header--links--is-desktop">
              {share && <OptionsModal {...share} theme="isArticleHeader"></OptionsModal>}
              {links?.map((link, i) => (
                <div key={i} className="article-header--download-link">
                  <Link {...link} iconBeforeChildren="download-round" />
                </div>
              ))}
            </div>
          </div>
        </>
      )}
    </div>
  );
};

ArticleHeader.displayName = 'ArticleHeader';

export default ArticleHeader;
